import { HttpErrorResponse } from '@angular/common/http';
import { TimeoutError } from 'rxjs';
import { GoogleAnalyticsErrorTypes } from '../google-analytics';

export function withErrorType() {
  const getErrorType = (error: unknown): GoogleAnalyticsErrorTypes => {
    if (error instanceof TimeoutError) {
      return GoogleAnalyticsErrorTypes.TIMEOUT;
    }

    if (error instanceof HttpErrorResponse) {
      if (error.error instanceof ErrorEvent || error.status === 0) {
        return GoogleAnalyticsErrorTypes.NETWORK_ERROR;
      }
      if (error.status >= 500) {
        return GoogleAnalyticsErrorTypes.SERVER_ERROR;
      }
      if (error.status === 400) {
        return GoogleAnalyticsErrorTypes.BAD_REQUEST;
      }
      if (error.status === 404) {
        return GoogleAnalyticsErrorTypes.NOT_FOUND;
      }
      if (error.status >= 400) {
        return GoogleAnalyticsErrorTypes.CLIENT_ERROR;
      }
    }

    return GoogleAnalyticsErrorTypes.UNKNOWN_ERROR;
  };

  const getErrorMessage = (error: unknown): string => {
    if (error instanceof TimeoutError) {
      return 'Request timed out';
    }

    if (error instanceof HttpErrorResponse) {
      const body = error.error;

      if (body && typeof body === 'object') {
        if ('errorMessage' in body && typeof body.errorMessage === 'string') {
          return body.errorMessage;
        }
        if ('message' in body && typeof body.message === 'string') {
          return body.message;
        }
      }
      return error.message || error.statusText || 'HTTP error occurred';
    }

    if (error instanceof Error) {
      return error.message;
    }

    return 'Unknown error';
  };

  return { getErrorType, getErrorMessage };
}
